module.exports = __webpack_public_path__ + "img/7-oneImg.9c799e7d.png";